import {pluralize, priceFormat} from "@pg-mono/string-utils";
import {Country, getPriceUnit} from "@pg-rp/common-types";

import {PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT} from "../constants/property_card_detail_offer_info_content";
import {IKeyVariable, IVariable} from "../types/IVariable";
import {IOffer} from "../types/property/IOffer";
import {IParkingPlace} from "../types/property/IParkingPlace";

export function formatParkingPlaceText(parkingPlace: IParkingPlace, parkingPlaceTypes: IKeyVariable[], country: Country) {
    const parkingPlaceLabel = parkingPlaceTypes.find((parking) => parking.value === parkingPlace.type)?.label.toLowerCase() ?? "";
    const quantityText = parkingPlace.quantity
        ? ` (${parkingPlace.quantity} ${pluralize([...PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.PARKING_QUANTITY_FORMS])(parkingPlace.quantity)})`
        : "";
    const priceText =
        parkingPlace.price != null
            ? `${PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.PARKING_PRICE_PREFIX}${priceFormat(parkingPlace.price, {unit: getPriceUnit(country)})}`
            : "";
    const descriptionText = parkingPlace.description ? `: ${parkingPlace.description}` : "";

    return `${parkingPlaceLabel}${quantityText}${priceText}${descriptionText}`;
}

export function getFacilitiesString(offer: IOffer, facilitiesInfo: IVariable[]) {
    if (!offer.facilities?.length) return undefined;

    return facilitiesInfo
        .filter((facility) => offer.facilities.includes(facility.value as number))
        .map((facility) => facility.label)
        .join(", ");
}

export function getRoomHeightText(offer: IOffer) {
    const rangesHeightMin = offer.stats?.ranges_height_min;
    const rangesHeightMax = offer.stats?.ranges_height_max;

    if (!rangesHeightMin) return undefined;

    if (rangesHeightMin === rangesHeightMax) return `${rangesHeightMin}cm`;

    return `${rangesHeightMin} - ${rangesHeightMax}cm`;
}

export function getStandardString(offer: IOffer, standardDescriptions: IKeyVariable[]) {
    if (!offer.standard_description?.types) return undefined;

    return standardDescriptions
        .filter((standard) => offer.standard_description.types.includes(standard.value as number))
        .map((standard) => standard.label)
        .join(", ");
}

export function getStorageText(offer: IOffer, country: Country) {
    if (!offer.storage) return PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.NOT_PLANNED;

    const {description, price, quantity} = offer.storage;
    const quantityText = quantity ? ` (${quantity})` : "";
    const descriptionText = description ? `: ${description}` : "";
    const priceText = price ? `${PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.STORAGE_PRICE_PREFIX}${priceFormat(price, {unit: getPriceUnit(country)})}` : "";

    return `${PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.STORAGE_HAS}${quantityText}${descriptionText}${priceText}`;
}
import {pluralize, priceFormat} from "@pg-mono/string-utils";
import {Country, getPriceUnit} from "@pg-rp/common-types";

import {PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT} from "../constants/property_card_detail_offer_info_content";
import {IKeyVariable, IVariable} from "../types/IVariable";
import {IOffer} from "../types/property/IOffer";
import {IParkingPlace} from "../types/property/IParkingPlace";

export function formatParkingPlaceText(parkingPlace: IParkingPlace, parkingPlaceTypes: IKeyVariable[], country: Country) {
    const parkingPlaceLabel = parkingPlaceTypes.find((parking) => parking.value === parkingPlace.type)?.label.toLowerCase() ?? "";
    const quantityText = parkingPlace.quantity
        ? ` (${parkingPlace.quantity} ${pluralize([...PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.PARKING_QUANTITY_FORMS])(parkingPlace.quantity)})`
        : "";
    const priceText =
        parkingPlace.price != null
            ? `${PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.PARKING_PRICE_PREFIX}${priceFormat(parkingPlace.price, {unit: getPriceUnit(country)})}`
            : "";
    const descriptionText = parkingPlace.description ? `: ${parkingPlace.description}` : "";

    return `${parkingPlaceLabel}${quantityText}${priceText}${descriptionText}`;
}

export function getFacilitiesString(offer: IOffer, facilitiesInfo: IVariable[]) {
    if (!offer.facilities?.length) return undefined;

    return facilitiesInfo
        .filter((facility) => offer.facilities.includes(facility.value as number))
        .map((facility) => facility.label)
        .join(", ");
}

export function getRoomHeightText(offer: IOffer) {
    const rangesHeightMin = offer.stats?.ranges_height_min;
    const rangesHeightMax = offer.stats?.ranges_height_max;

    if (!rangesHeightMin) return undefined;

    if (rangesHeightMin === rangesHeightMax) return `${rangesHeightMin}cm`;

    return `${rangesHeightMin} - ${rangesHeightMax}cm`;
}

export function getStandardString(offer: IOffer, standardDescriptions: IKeyVariable[]) {
    if (!offer.standard_description?.types) return undefined;

    return standardDescriptions
        .filter((standard) => offer.standard_description.types.includes(standard.value as number))
        .map((standard) => standard.label)
        .join(", ");
}

export function getStorageText(offer: IOffer, country: Country) {
    if (!offer.storage) return PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.NOT_PLANNED;

    const {description, price, quantity} = offer.storage;
    const quantityText = quantity ? ` (${quantity})` : "";
    const descriptionText = description ? `: ${description}` : "";
    const priceText = price ? `${PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.STORAGE_PRICE_PREFIX}${priceFormat(price, {unit: getPriceUnit(country)})}` : "";

    return `${PROPERTY_CARD_DETAIL_OFFER_INFO_CONTENT.STORAGE_HAS}${quantityText}${descriptionText}${priceText}`;
}
